module.exports = __webpack_public_path__ + "img/aymeric-aveline-thumbnail1.706ad426.png";